import { helpers } from 'vuelidate/lib/validators';
import REGEX from '../constants/regex';

export const alphaDash = helpers.regex('alpha', REGEX.alphaDash);
export const alphaNum = helpers.regex('alpha', REGEX.alphaNum);
export const mobile = helpers.regex('mobile', REGEX.mobile);
export const email = helpers.regex('email', REGEX.email);
export const numeric = helpers.regex('numeric', REGEX.numeric);
